import { isCurrentAppTheme } from 'appConfig';

export type CampaignStep = 'budget' | 'summary' | 'audiences' | 'locations' | 'ads-and-keywords';

/**
 * This is an ordered list of the campaign's steps. We base our routing flow on this order.
 */
export function useGetOrderedCampaignsSteps(): CampaignStep[] {
  const ORDERED_CAMPAIGN_STEPS: CampaignStep[] = ['locations', 'ads-and-keywords', 'audiences', 'budget', 'summary'];

  const ORDERED_CAMPAIGN_STEPS_CA: CampaignStep[] = ['locations', 'audiences', 'ads-and-keywords', 'budget', 'summary'];

  const isCanadianTheme = isCurrentAppTheme('yp-ca');

  return isCanadianTheme ? ORDERED_CAMPAIGN_STEPS_CA : ORDERED_CAMPAIGN_STEPS;
}
